export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/4131350a-9ef1-48f0-8188-046dddb3074d/product-uploads/'

export const insideItems: string[] = [
  'Anatomy of a bar & the workstation',
  'Essential bar tools, labeled',
  'Glassware families & capacities',
  'Ice types & dilution',
  'Jigger accuracy & free pouring',
  'Shake vs. stir decision rules',
  'Straining, muddling & dry shaking',
  'How to read a cocktail spec',
  'The golden ratio for sours',
  'Cocktail families map',
  'Classic cocktail specs in ml & oz',
  'Zero-proof classics',
  'Syrups, infusions & shrubs',
  'Clarification & carbonation',
  'Foams, smoke & aroma',
  'Creating a signature cocktail',
  'How spirits are made',
  'Gin botanicals & whisky styles',
  'Liqueurs, bitters & mixers',
  'Spirits tasting grid',
  'Garnish techniques step by step',
  'Cocktail menu design',
  'Costing & pour cost',
  'Inventory & bar operations',
  'Responsible alcohol service',
  'Lesson plans by level',
  'Practical exams & rubrics',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
  'Bartending training programs',
]

/**
 * Carousel slides — one real page per volume.
 * Slides 3–6 (Vol 3 to Vol 6) are pending: upload the JPG to a public URL and
 * add an entry below following the same structure (src, alt, title, caption).
 */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_933f964e-bb4f-41ec-b86a-32a166415395_1793726240718.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 1 page: Glassware Families, silhouettes, names and typical capacities of 12 bar glasses',
    title: 'Vol 1 — Glassware Families',
    caption: 'Vol 1 — Bartending Fundamentals, Bar Tools, Glassware & Essential Techniques: 12 glass shapes with capacities in ml and oz, plus an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_49a92b37-ba6f-4770-ac8f-0784cbd2078b_1793726243892.png`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 2 page: Margarita classic spec, step-by-step build, mistake vs. correct, cue, drill and quick check',
    title: 'Vol 2 — Margarita',
    caption: 'Vol 2 — Classic Cocktails, International Recipes & Drink Preparation: classic spec in ml/oz, 5-step build, ❌/✅ salt rim, drill and quick check.',
  },
  // SLOT 3 — Vol 3 — Advanced Mixology, Molecular Techniques & Creative Cocktails (pending)
  // SLOT 4 — Vol 4 — Spirits, Liqueurs, Flavor Profiles & Sensory Analysis (pending)
  // SLOT 5 — Vol 5 — Cocktail Presentation, Garnishing, Menu Design & Bar Operations (pending)
  // SLOT 6 — Vol 6 — Bartending Instruction, Training Programs & Practical Assessments (pending)
]
